import { Box, Button, Spinner } from "@adfenix/alexandria";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";
import { getCampaignStatus } from "api/services/campaignService";
import { useQuery } from "@tanstack/react-query";

interface ViewResultsButtonProps {
  hqId: string;
  propertyId: string;
}

export const ViewResultsButton = ({
  hqId,
  propertyId
}: ViewResultsButtonProps) => {
  const { t } = useTranslation();

  const { data: status, isInitialLoading: isLoading } = useQuery(
    ["getCampaignStatus", propertyId],
    () => getCampaignStatus(propertyId!),
    {
      enabled: Boolean(propertyId)
    }
  );

  if (isLoading)
    return (
      <Box
        style={{
          width: 80,
          height: 24,
          position: "relative",
          marginLeft: "16px"
        }}
      >
        <Spinner size={24} centered />
      </Box>
    );

  const campaignsWithResults = status === "Active" || status === "Completed";

  return campaignsWithResults ? (
    <Link
      style={{ marginLeft: "16px" }}
      to={`/customer/hq/${hqId}/property/results/${propertyId}`}
    >
      <Button logLabel="view-results-button" variant="primary">
        {t("listings.property.actions.stats")}
      </Button>
    </Link>
  ) : null;
};
